const lastDataUpdate = '2020-11-10T00:00:00.000Z';

const enabledModels = ['ms', 'mx', 'm3', 'my'];
// EU, AE, JO, KR (Model 3 is not yet available in these markets)
const localeRestrictions = {
  m3: ['EU', 'AE', 'JO', 'KR'],
  my: ['AE', 'AU', 'CZ', 'EU', 'GB', 'HK', 'IE', 'IS', 'JO', 'JP', 'KR', 'MO', 'NZ', 'TW'],
};

const vehicles = {
  MS: [
    {
      rangeType: 'longRangePlus',
      shortName: 'Model S',
      model: 'MS_2020_LongRange',
      optionAPICode: '$MTS07',
      driveTrainType: 'allWeelDrive',
    },
    {
      rangeType: 'performance',
      shortName: 'Model S',
      model: 'MS_2020_Performance',
      optionAPICode: '$MTS08',
      driveTrainType: 'allWeelDrive',
    },
  ],
  MX: [
    {
      rangeType: 'longRangePlus',
      shortName: 'Model X',
      model: 'MX_2020_LongRange',
      optionAPICode: '$MTX07',
      driveTrainType: 'allWeelDrive',
    },
    {
      rangeType: 'performance',
      shortName: 'Model X',
      model: 'MX_2020_Performance',
      optionAPICode: '$MTX08',
      driveTrainType: 'allWeelDrive',
    },
  ],
  M3: [
    {
      rangeType: 'standardRangePlus',
      shortName: 'Model 3',
      model: 'M3_2020_StandardRangePlus',
      optionAPICode: '$MT314',
      driveTrainType: 'rearWeelDrive',
    },
    {
      rangeType: 'longRange',
      shortName: 'Model 3',
      model: 'M3_2020_LongRange',
      optionAPICode: '$MT315',
      driveTrainType: 'allWeelDrive',
    },
    {
      rangeType: 'performance',
      shortName: 'Model 3',
      model: 'M3_2020_Performance',
      optionAPICode: '$MT317',
      driveTrainType: 'allWeelDrive',
    },
  ],
  MY: [
    {
      rangeType: 'longRange',
      shortName: 'Model Y',
      model: 'MY_2020_LongRange',
      optionAPICode: '$MTY03',
      driveTrainType: 'allWeelDrive',
    },
    {
      rangeType: 'performance',
      shortName: 'Model Y',
      model: 'MY_2020_Performance',
      optionAPICode: '$MTY05',
      driveTrainType: 'allWeelDrive',
    },
  ],
};

// eslint-disable-next-line object-curly-newline
export { enabledModels, lastDataUpdate, localeRestrictions, vehicles };
